/* IM8 Foundation Quiz — remaining-edition data.
 * Drop-in for Kev's writer lane. Do not paste into the live checkout from this file
 * without Kev integrating. Matches the live Beckham P contract in
 * assets/im8-foundation-quiz.js plus the fields the source engine already interpolates.
 *
 * Live JS currently hardcodes Beckham in three places besides `var P`:
 *   topbar()   img('beckhamHero') + "With David"
 *   intro()    img('beckhamHero') + hardcoded hook HTML
 *   scoreCard() img('beckhamHero')
 * Replace those with P.heroAsset / P.full / P.first / P.hook. See js-P-lookup.patch.js.
 */
(function (root) {
  var PEOPLE = {
    beckham: {
      slug: 'beckham',
      full: 'David Beckham',
      first: 'David',
      last: 'Beckham',
      role: 'Co-founding Partner',
      roleShort: 'Co-Founding Partner',
      roleLine: 'Co-founding Partner of IM8. Decades of elite football, one daily foundation.',
      accent: '#F0C96B',
      hook: ['Find out what your', 'body is actually ', 'short of', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to David Beckham’s, and name the three gaps holding you back.',
      quote: '“Supplements have been a part of my daily routine for years, but I’ve often felt overwhelmed by how many different products it takes to truly support your body.”',
      attr: 'David Beckham · Co-founding Partner',
      claim: null,
      baseline: 88,
      focal: '50% 12%',
      heroInset: '460px',
      heroField: '#7f6b55',
      heroAsset: 'beckhamHero',
      publish: true
    },
    aryna: {
      slug: 'aryna',
      full: 'Aryna Sabalenka',
      first: 'Aryna',
      last: 'Sabalenka',
      role: 'World No. 1 · 4x Grand Slam Champion',
      accent: '#FFB9A8',
      hook: ['Find out what your', 'engine is ', 'running without', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Aryna Sabalenka’s, and name the three gaps holding you back.',
      quote: '“When you compete at the highest level, nutrition isn’t optional — it’s everything.”',
      attr: 'Aryna Sabalenka · 4x Grand Slam Champion',
      claim: null,
      baseline: 91,
      focal: '50% 11%',
      heroInset: '460px',
      heroField: '#4c000c',
      heroAsset: 'arynaHero',
      publish: true
    },
    giannis: {
      slug: 'giannis',
      full: 'Giannis Antetokounmpo',
      first: 'Giannis',
      last: 'Antetokounmpo',
      role: '2x NBA MVP · 10x NBA All-Star',
      accent: '#FFC97A',
      hook: ['Find out what your', 'body is ', 'running short of', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Giannis Antetokounmpo’s, and name the three gaps holding you back.',
      quote: '“Where I grew up, we didn’t have supplements. We didn’t have a nutritionist. We had whatever food was available that day.”',
      attr: 'Giannis Antetokounmpo · 2x MVP, 10x NBA All-Star',
      claim: null,
      baseline: 92,
      focal: '50% 10%',
      heroInset: '460px',
      heroField: '#820e1b',
      heroAsset: 'giannisHero',
      publish: true
    },
    jay: {
      slug: 'jay',
      full: 'Jay Shetty',
      first: 'Jay',
      last: 'Shetty',
      role: '#1 NYT Bestselling Author · Host of On Purpose',
      accent: '#E8CBA6',
      hook: ['Find out what your', 'clarity is ', 'actually missing', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Jay Shetty’s, and name the three gaps holding you back.',
      quote: '“More stable energy throughout the day, sharper focus when I’m recording and writing, and a morning routine that finally feels foundational instead of complicated.”',
      attr: 'Jay Shetty · #1 New York Times Bestselling Author',
      claim: null,
      baseline: 88,
      focal: '50% 11%',
      heroInset: '460px',
      heroField: '#909a6e',
      heroAsset: 'jayHero',
      publish: true
    },
    lily: {
      slug: 'lily',
      full: 'Lily Collins',
      first: 'Lily',
      last: 'Collins',
      role: 'Emily in Paris Star & IM8 Global Ambassador',
      roleShort: 'Global Ambassador',
      roleLine: 'Emily in Paris star. Six time zones, five call times, one body to get through all of it.',
      accent: '#F2C4C0',
      hook: ['Find out what your', 'schedule is ', 'quietly costing you', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Lily Collins’s, and name the three gaps holding you back.',
      quote: '“I was a customer of IM8 for months before I became a partner.”',
      attr: 'Lily Collins · IM8 Global Ambassador',
      claim: null,
      baseline: 87,
      focal: '50% 10%',
      heroInset: '520px',
      heroField: '#e1e1e4',
      heroAsset: 'lilyHero',
      publish: true
    },
    tavi: {
      slug: 'tavi',
      full: 'Tavi Castro',
      first: 'Tavi',
      last: 'Castro',
      role: 'Freediver · Actor · IM8 Global Ambassador',
      roleShort: 'Global Ambassador',
      roleLine: 'Freediver and actor. One breath, no equipment to blame and nowhere to hide.',
      accent: '#8FD3E8',
      hook: ['Find out what your', 'body is ', 'holding back', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Tavi Castro’s, and name the three gaps holding you back.',
      quote: '“There is no equipment to blame and nowhere to hide.”',
      attr: 'Tavi Castro · Freediver & IM8 Global Ambassador',
      claim: null,
      baseline: 90,
      focal: '50% 14%',
      heroInset: '460px',
      heroField: '#f1efeb',
      heroAsset: 'taviHero',
      publish: true
    },
    bobby: {
      slug: 'bobby',
      full: 'Bobby Rich',
      first: 'Bobby',
      last: 'Rich',
      role: 'Performance Coach · David Beckham’s Personal Trainer',
      roleShort: 'Founding Ambassador',
      roleLine: 'Performance coach and 3rd-degree judo black belt. The man who trains David Beckham.',
      accent: '#C9D1D9',
      hook: ['Find out what your', 'training is ', 'running on', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Bobby Rich’s, and name the three gaps holding you back.',
      quote: '“You perform the way you live.”',
      attr: 'Bobby Rich · Performance Coach & Founding Ambassador',
      claim: null,
      baseline: 89,
      focal: '50% 12%',
      heroInset: '460px',
      heroField: '#d3c2ae',
      heroAsset: 'bobbyHero',
      publish: true
    },
    dustin: {
      slug: 'dustin',
      full: 'Dustin Poirier',
      first: 'Dustin',
      last: 'Poirier',
      role: 'Former UFC Interim Lightweight Champion',
      roleShort: 'Global Ambassador',
      roleLine: 'Former UFC Interim Lightweight Champion. There are no shortcuts at this level.',
      accent: '#FF8A80',
      hook: ['Find out what your', 'recovery is ', 'actually missing', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Dustin Poirier’s, and name the three gaps holding you back.',
      quote: '“After my team checked out the science, partnering with IM8 was a no-brainer.”',
      attr: 'Dustin Poirier · Former UFC Interim Lightweight Champion',
      claim: null,
      baseline: 91,
      focal: '50% 8%',
      heroInset: '520px',
      heroField: '#878a58',
      heroBleed: true,
      heroAsset: 'dustinHero',
      publish: true
    },
    amy: {
      slug: 'amy',
      full: 'Dr. Amy Shah',
      first: 'Amy',
      last: 'Shah',
      role: 'Double Board-Certified MD · IM8 Scientific Advisory Board',
      roleShort: 'Scientific Advisory Board',
      roleLine: 'Double board-certified physician, trained at Cornell, Columbia and Harvard. Gut, hormones and energy are one conversation.',
      accent: '#F4B6C2',
      hook: ['Find out what your', 'energy is ', 'actually made of', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Dr. Amy Shah’s, and name the three gaps holding you back.',
      quote: '“Energy isn’t a mystery — it’s your gut, hormones and daily inputs working together.”',
      attr: 'Dr. Amy Shah · IM8 Scientific Advisory Board',
      claim: null,
      baseline: 89,
      focal: '50% 12%',
      heroInset: '520px',
      heroField: '#9d8d7b',
      heroBleed: true,
      heroAsset: 'amyHero',
      publish: true
    },
    james: {
      slug: 'james',
      full: 'Dr. James DiNicolantonio',
      first: 'Dr. James',
      last: 'DiNicolantonio',
      role: 'Cardiovascular Research Scientist · Doctor of Pharmacy',
      roleShort: 'Scientific Advisory Board',
      roleLine: 'Cardiovascular research scientist with 300+ peer-reviewed publications. Science-backed formulation is the whole point.',
      accent: '#FFB07A',
      hook: ['Find out what your', 'heart is ', 'quietly short of', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Dr. James DiNicolantonio’s, and name the three gaps holding you back.',
      quote: '“I joined IM8 because I’ve seen firsthand the power of nutrition in transforming health.”',
      attr: 'Dr. James DiNicolantonio · IM8 Scientific Advisory Board',
      claim: null,
      baseline: 90,
      focal: '50% 10%',
      heroInset: '460px',
      heroField: '#3f4412',
      heroAsset: 'jamesHero',
      publish: true
    },
    ollie: {
      slug: 'ollie',
      full: 'Ollie Bearman',
      first: 'Ollie',
      last: 'Bearman',
      role: 'Formula 1 Driver · Youngest Ever British F1 Driver',
      roleShort: 'Global Ambassador & Shareholder',
      roleLine: 'Formula 1 driver. The youngest British driver to start a Grand Prix.',
      accent: '#C8102E',
      hook: ['Find out what your', 'race day is ', 'built on', '.'],
      lede: 'Eight questions about your energy, sleep, gut and decade. We score five pillars, put your score next to Ollie Bearman’s, and name the three gaps holding you back.',
      quote: '“As the youngest British F1 driver, I need every edge. IM8 gives me the daily nutrition foundation so I can focus on what matters — performance on race day.”',
      attr: 'Ollie Bearman · Formula 1 Driver',
      claim: null,
      baseline: 91,
      focal: '50% 18%',
      heroInset: '460px',
      heroField: '#fdfeff',
      heroBleed: true,
      heroAsset: 'ollieHero',
      publish: true
    }
  };

  function selectPerson(root) {
    var slug = (root && (root.getAttribute('data-edition') || (root.dataset && root.dataset.edition))) || 'beckham';
    var P = PEOPLE[slug] || PEOPLE.beckham;
    if (P.publish === false && root) root.setAttribute('data-edition-publishable', 'false');
    return P;
  }

  root.IM8_FOUNDATION_PEOPLE = PEOPLE;
  root.IM8_selectPerson = selectPerson;
})(typeof window !== 'undefined' ? window : this);
